// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginValidate_wrapper__0hC0A","container":"LoginValidate_container__Zwakq","content":"LoginValidate_content__AbPNv"};